import {css} from 'lit';
export const styles = css`.btn-v1 {
  --background: transparent;
  --background-hover: transparent;
  --background-active: transparent;
  --border-color: transparent;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background-color: var(--background);
  color: var(--text-primary);
  font-size: 14px;
  font-size: var(--font-size-base, 14px);
  line-height: 1.4;
  white-space: nowrap;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

  .btn-v1 ef-icon {
    margin-right: 0.3em;
    font-size: 1.33em;
    font-size: var(--icon-size-primary, 1.33em);
  }

  @media (max-width: 399px) {.btn-v1 {
    --font-size-base: 12px;

    padding: 8px
}
  }

  @media (min-width: 400px) {.btn-v1 {
    display: inline-flex;
    width: auto
}
  }

  @media (hover: hover) {
    .btn-v1:hover {
      color: var(--text-primary);
      color: var(--text-primary-hover, var(--text-primary));
      background-color: var(--background-hover);
      filter: contrast(1.4);
    }
  }

  .btn-v1:active {
    color: var(--text-primary);
    color: var(--text-primary-active, var(--text-primary));
    background-color: var(--background-active);
    filter: contrast(1);
  }

  .btn-v1.t1 {
    --text-primary: var(--contrast-light);
    --background: var(--primary);
    --background-hover: var(--primary);
    --background-active: var(--primary);
  }

  .btn-v1.t2 {
    --text-primary: var(--contrast-light);
    --background: var(--secondary);
    --background-hover: var(--secondary);
    --background-active: var(--secondary);
  }

  .btn-v1.t3 {
    --text-primary: var(--contrast-light);
    --background: var(--success);
    --background-hover: var(--success);
    --background-active: var(--success);
  }

  .btn-v1.t4 {
    --text-primary: var(--contrast-light);
    --background: var(--danger);
    --background-hover: var(--danger);
    --background-active: var(--danger);
  }

  .btn-v1.t5 {
    --text-primary: var(--contrast-light);
    --background: var(--warning);
    --background-hover: var(--warning);
    --background-active: var(--warning);
  }

  .btn-v1.t6 {
    --text-primary: var(--contrast-light);
    --background: var(--info);
    --background-hover: var(--info);
    --background-active: var(--info);
  }

  .btn-v1.t7 {
    --background: var(--gray-200);
    --background-hover: var(--gray-200);
    --background-active: var(--gray-200);
    --border-color: var(--gray-400);
  }

  @media (hover: hover) {
      .btn-v1.t7:hover {
        filter: contrast(0.7);
      }
    }

  .btn-v1.t7:active {
      filter: contrast(0.5);
    }

  .btn-v1.btn-outline {
    --background: transparent;
    --text-primary-hover: var(--contrast-light);
    --text-primary-active: var(--contrast-light);
  }

  .btn-v1.btn-outline.t1 {
      --text-primary: var(--primary);
      --border-color: var(--primary);
    }

  .btn-v1.btn-outline.t2 {
      --text-primary: var(--secondary);
      --border-color: var(--secondary);
    }

  .btn-v1.btn-outline.t3 {
      --text-primary: var(--success);
      --border-color: var(--success);
    }

  .btn-v1.btn-outline.t4 {
      --text-primary: var(--danger);
      --border-color: var(--danger);
    }

  .btn-v1.btn-outline.t5 {
      --text-primary: var(--warning);
      --border-color: var(--warning);
    }

  .btn-v1.btn-outline.t6 {
      --text-primary: var(--info);
      --border-color: var(--info);
    }

  .btn-v1.btn-outline.t7 {
      --text-primary: var(--gray-900);
      --border-color: var(--gray-500);
      --text-primary-hover: var(--gray-900);
      --text-primary-active: var(--gray-900);
    }

  .btn-v1.btn-sm {
    --font-size-base: 12px;

    padding: 4px 8px;
  }

  .btn-v1.btn-round {
    border-radius: 20px;
  }

  .btn-v1[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }

  ef-grid-list .btn-v1 {
    width: auto;
  }
`;
export default styles;
